import InvitationsList from './InvitationsList';
export default InvitationsList;